module.exports = __webpack_public_path__ + "img/groups-logo-active.75414293.svg";